import { 
  selectedAccountId, 
  isProcessingAccountSelection, 
  currentView,
  propertyError
} from '../state'
import { saveAccountSelection } from '../../../services/google/methods/save-account-selection'
import { loadGoogleProperties } from './load-properties'
import { responseHandlerService } from '@/plugins/responseHandlerService'

/**
 * Processes the account selection and transitions to property selection
 * @param {Function} t - Translation function passed from parent
 */
export const accountSelected = async (t) => {
  if (!selectedAccountId.value) return

  isProcessingAccountSelection.value = true

  try {
    // Save selected account
    const success = await saveAccountSelection(selectedAccountId.value)
    
    if (success) {
      // Transition to properties view
      currentView.value = 'properties'
      
      // Load properties for the selected account
      try {
        await loadGoogleProperties()
      } catch (error) {
        propertyError.value = 'Mülkler yüklenirken bir hata oluştu. Lütfen tekrar deneyin.'
      }
    } else {
      responseHandlerService.handleError(
        null,
        t('settings.components.integrations.responseHandler.errors.googleAccountSelect')
      )
    }
  } catch (error) {
    responseHandlerService.handleError(
      error,
      t('settings.components.integrations.responseHandler.errors.googleAccountSelect')
    )
  } finally {
    isProcessingAccountSelection.value = false
  }
}